import React from 'react';
import MainComponent from '../components/LandingPage/MainComponent';

function HomePage() {
  return (
    <div>
      <MainComponent />
    </div>
  )
}

export default HomePage;